export default method => {
  switch (method) {
    case "payAtDoor":
      return "Kapıda Ödeme";
      break;
    case "transfer":
      return "Havale / EFT";
      break;
    case "online":
      return "Kredi Kardı İle Ödeme";
      break;
    default:
      return "Ödeme";
  }
};



// WEBPACK FOOTER //
// ./src/helpers/writeMethod.js